// extracted by mini-css-extract-plugin
export default {"pchart":"styles_pchart__5ZR6P"};